import React, { useState, useEffect } from 'react';
import './App.css';
import { t } from './i18n';
import BlacklistDisplay from './components/BlacklistDisplay';
import ViewingTimeDisplay from './components/ViewingTimeDisplay';
import CategoryManager from './components/CategoryManager';
import CategoryStats from './components/CategoryStats';
import PrivacyPolicy from './components/PrivacyPolicy';

type ActivePage = 'blacklist' | 'viewingTime' | 'categories' | 'categoryStats' | 'privacy';

function getPageFromPath(): ActivePage {
  const path = window.location.pathname;
  if (path === '/privacy') return 'privacy';
  if (path === '/categories') return 'categories';
  if (path === '/category-stats') return 'categoryStats';
  if (path === '/viewing-time') return 'viewingTime';
  return 'blacklist';
}

function App() {
  const [activePage, setActivePage] = useState<ActivePage>(getPageFromPath);

  const navigateTo = (page: ActivePage) => {
    const pathMap: Record<ActivePage, string> = {
      blacklist: '/',
      viewingTime: '/viewing-time',
      categories: '/categories',
      categoryStats: '/category-stats',
      privacy: '/privacy',
    };
    window.history.pushState({}, '', pathMap[page]);
    setActivePage(page);
  };

  useEffect(() => {
    const handlePopState = () => {
      setActivePage(getPageFromPath());
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <div className="App">
      {/* ナビゲーションヘッダー */}
      <nav style={{
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0',
        padding: '0',
        marginBottom: '20px'
      }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center'
        }}>
          <button
            onClick={() => navigateTo('blacklist')}
            style={{
              padding: '16px 24px',
              border: 'none',
              backgroundColor: activePage === 'blacklist' ? '#ffffff' : 'transparent',
              borderBottom: activePage === 'blacklist' ? '2px solid #007bff' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activePage === 'blacklist' ? 'bold' : 'normal',
              color: activePage === 'blacklist' ? '#007bff' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            {t('navBlacklist')}
          </button>

          <button
            onClick={() => navigateTo('viewingTime')}
            style={{
              padding: '16px 24px',
              border: 'none',
              backgroundColor: activePage === 'viewingTime' ? '#ffffff' : 'transparent',
              borderBottom: activePage === 'viewingTime' ? '2px solid #007bff' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activePage === 'viewingTime' ? 'bold' : 'normal',
              color: activePage === 'viewingTime' ? '#007bff' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            {t('navViewingTime')}
          </button>

          <button
            onClick={() => navigateTo('categories')}
            style={{
              padding: '16px 24px',
              border: 'none',
              backgroundColor: activePage === 'categories' ? '#ffffff' : 'transparent',
              borderBottom: activePage === 'categories' ? '2px solid #007bff' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activePage === 'categories' ? 'bold' : 'normal',
              color: activePage === 'categories' ? '#007bff' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            {t('navCategories')}
          </button>

          <button
            onClick={() => navigateTo('categoryStats')}
            style={{
              padding: '16px 24px',
              border: 'none',
              backgroundColor: activePage === 'categoryStats' ? '#ffffff' : 'transparent',
              borderBottom: activePage === 'categoryStats' ? '2px solid #007bff' : '2px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activePage === 'categoryStats' ? 'bold' : 'normal',
              color: activePage === 'categoryStats' ? '#007bff' : '#666',
              transition: 'all 0.2s ease'
            }}
          >
            {t('navCategoryStats')}
          </button>

          <a
            href="https://chromewebstore.google.com/detail/pleijhempjpmjogomoabhibenbjekhlj"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              marginLeft: 'auto',
              padding: '8px 16px',
              fontSize: '13px',
              color: '#007bff',
              textDecoration: 'none',
              border: '1px solid #007bff',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease'
            }}
          >
            Chrome Web Store
          </a>
        </div>
      </nav>

      {/* ページコンテンツ */}
      <div style={{ minHeight: 'calc(100vh - 170px)' }}>
        {activePage === 'blacklist' ? (
          <BlacklistDisplay />
        ) : activePage === 'viewingTime' ? (
          <ViewingTimeDisplay />
        ) : activePage === 'categories' ? (
          <CategoryManager />
        ) : activePage === 'categoryStats' ? (
          <CategoryStats />
        ) : (
          <PrivacyPolicy />
        )}
      </div>

      {/* フッター */}
      <footer style={{
        borderTop: '1px solid #e0e0e0',
        padding: '16px 0',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        fontSize: '13px',
        color: '#888'
      }}>
        <button
          onClick={() => navigateTo('privacy')}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            fontSize: '13px',
            textDecoration: 'underline'
          }}
        >
          {t('footerPrivacyPolicy')}
        </button>
      </footer>
    </div>
  );
}

export default App;
